/*require('babel-polyfill');
require('es6-promise/auto');
require('core-js/es6/set');
require('core-js/fn/array/from');
*/
import Vue from 'vue'

//import 'es6-promise/auto'
//es6Promise.polyfill();

//import 'babel-polyfill'
//import 'core-js/es6/set'
//import 'core-js/fn/array/from'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import MultiLanguage from 'vue-multilanguage'
Vue.use(MultiLanguage, {
	default: 'de',
	de: {
    acting: 'Schauspiel',
    agentur: 'Agentur',
    kontakt: 'Kontakt',
    schauspielerinnen: 'Schauspielerinnen',
    schauspieler: 'Schauspieler',
    vita: 'Vita',
    auszeichnungen: 'Auszeichnungen',
    filmTv: 'Film/TV (Auswahl)',
    theater: 'Theater (Auswahl)',
    sonstiges: 'Sonstiges (Auswahl)',
    geburtsjahr: 'Geburtsjahr',
    nationalitaet: 'Nationalität',
    groesse: 'Größe',
    haarfarbe: 'Haarfarbe',
    augenfarbe: 'Augenfarbe',
    sprachen: 'Sprachen',
    dialekte: 'Dialekte',
    akzent: 'Akzent',
    fuehrerschein: 'Führerschein',
    sport: 'Sport',
    specials: 'Specials',
    musik: 'Musik',
    wohnort: 'Wohnort',
    wohnmoeglichkeit: 'Wohnmöglichkeit',
    website: 'Website',
    ausbildung: 'Ausbildung',
    agenturText1: 'Nach meinem Magister-Studium in Köln (Germanistik, Kunstgeschichte, Geschichte) arbeitete ich sechs Jahre bei einer Kölner Filmproduktion. Danach baute ich 1999-2005 in einer Managementagentur für Moderatoren und Schauspieler den bis dahin noch in den Anfängen steckenden Schauspielbereich auf.',
    agenturText2: 'Im Januar 2006 eröffnete ich Heimann.s Agentur und vertrete dort bis zu 32 Schauspielerinnen und  Schauspieler. Und wie auf den jeweiligen einzelnen Seiten dieser Damen und Herren hier zu sehen ist, ergeben sich seitdem immer wieder sehr schöne Engagements - diesbezüglich herzlichen Dank  für das entgegengebrachte Vertrauen an alle beteiligten Entscheidungsträger!',
    agenturText3: 'Und natürlich bedanke ich mich auch bei all meinen SchauspielerInnen für die Zusammenarbeit - es macht große Freude, mit Euch zu arbeiten!',
    agenturText4: 'Seit 2011 ist Heimann.s Agentur Mitglied der DAFF-Deutsche Akademie für Fernsehen und von 2012-2016 dort im Vorstand tätig. Seit Oktober 2018 ist Heimann.s Agentur Mitglied im Verband der Agenturen.',
    schreibenSieUns: 'Schreiben Sie uns!',
    ihrName:'Ihr Name',
    ihreEmail:'Ihre Email',
    betreff:'Betreff',
    ihreNachricht: 'Ihre Nachricht',
    absenden:'Absenden',
    nachrichtVersendet: 'Vielen Dank. Ihre Nachricht wurde versendet.',
    fehlerNochmal: 'Ein Fehler ist aufgetreten! Bitte versuchen Sie es später erneut.',
    daff: 'Heimann.s Agentur ist Mitglied',
    drucken: 'Drucken',
    download: 'Herunterladen'
	},
	fr: {
    acting: 'Acteur',
    agentur: 'Agence',
    kontakt: 'Contact',
    schauspielerinnen: 'Actrices (f)',
    schauspieler: 'Actrices (m)',
    vita: 'Vitæ',
    auszeichnungen: 'Prix',
    filmTv: 'Film/TV (sélection)',
    theater: 'Théâtre (sélection)',
    sonstiges: 'D´autres (sélection)',
    geburtsjahr: 'Date de naissance',
    nationalitaet: 'Nationalité',
    groesse: 'Größe',
    haarfarbe: 'Haarfarbe',
    augenfarbe: 'Augenfarbe',
    sprachen: 'Sprachen',
    akzent: 'Akzent',
    fuehrerschein: 'Führerschein',
    sport: 'Sport',
    specials: 'Specials',
    musik: 'Musik',
    wohnort: 'Wohnort',
    wohnmoeglichkeit: 'Wohnmöglichkeit',
    website: 'Website',
    ausbildung: 'Ausbildung',
    agenturText1: 'Nach meinem ...',
    agenturText2: 'Im Januar 2006...',
    agenturText3: 'Und natürlich...',
    agenturText4: 'Seit 2011...',
    schreibenSieUns: 'Ecrivez-nous!',
    ihrName:'Votre nom',
    ihreEmail:'Votre émail',
    betreff:'L´objet',
    ihreNachricht: 'Votre message',
    absenden: 'Envoyer',
    nachrichtVersendet: 'Merci beaucoup. Votre message était envoyé.',
    fehlerNochmal: 'Erreur! Essayez-vous encore une fois plus tard, s´il vous plaît.',
    daff: 'Heimann.s Agentur est membre',
    drucken: 'Imprimer',
    download: 'Download'
	},
})

//import VueRouter from 'vue-router';
//import { routes } from './routes';
//Vue.use(VueRouter);


//const router = new VueRouter({
//    routes
//});
import VueLazyLoad from 'vue-lazyload'
import VueTouch from 'vue-touch'

Vue.use(VueLazyLoad)
Vue.use(VueTouch, { name: 'v-touch' })


import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css' // require styles
Vue.use(VueAwesomeSwiper, /* { default global options } */)

import App from './App'

import vueSmoothScroll from 'vue-smooth-scroll'
Vue.use(vueSmoothScroll)

import MQ from 'vue-match-media/src'
Vue.use(MQ)

import VueResource from 'vue-resource'
Vue.use(VueResource)

export const eventBus = new Vue();

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  //router,
  created() {
/*    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/de_DE/sdk.js#xfbml=1&version=v2.11';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));*/
  },
  render: h => h(App)
  , mq: {
    //phone: '(max-width: 768px)',
    //tablet: '(max-width: 1024px)',
    //desktop: '(min-width: 1024px)', 

    // Exta small devices (portrait Mobile) // max-width 575px
    xs        : 'only screen and (max-width: 575px)',    
    // Mobile // min-width 576px and max-width 767px
    sm        : 'only screen and (min-width: 576px) and (max-width: 767px)',
    //smUp      : 'only screen and (min-width: 576px)',
    //smDown    : 'only screen and (max-width: 767px)',  
    // Tablet // min-width 768px and max-width 991px
    md        : 'only screen and (min-width: 768px) and (max-width: 991px)',
    //mdUp      : 'only screen and (min-width: 768px)',
    //mdDown    : 'only screen and (max-width: 991px)',    
    // Desktop // min-width 992px and max-width 1199px
    lg        : 'only screen and (min-width: 992px) and (max-width: 1199px)',
    //lgUp      : 'only screen and (min-width: 992px)',
    //lgDown    : 'only screen and (max-width: 1199px)',   
    // Large Desktop // min-width 1200px
    xl        : 'only screen and (min-width: 1200px)',
    // detect portrait orientation
    //portrait  : 'only screen and (orientation: portrait)',
    // detect portrait orientation
    //landscape : 'only screen and (orientation: landscape)'
  } 
})



// WEBPACK FOOTER //
// ./src/main.js